import { render } from "./FilterDuration.vue?vue&type=template&id=6f82cf95"
import script from "./FilterDuration.vue?vue&type=script&lang=js"
export * from "./FilterDuration.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__